<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormCuentaCobrar" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div v-if="objCuentaPorCobrar.IdCuentaCobrar==0" class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                    <div class="form-check">
                                        <input type="radio" v-model="TipoLista" class="form-check-input" name="flexRadioDefault" id="flexRadioDefault1" value="1" @change="ListarTipoCuenta">
                                        <label class="form-check-label" for="flexRadioDefault1">
                                            Facturas
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                    <div class="form-check">
                                        <input type="radio" v-model="TipoLista" class="form-check-input" name="flexRadioDefault" id="flexRadioDefault2" value="2" @change="ListarTipoCuenta">
                                        <label class="form-check-label" for="flexRadioDefault2">
                                            Notas de Venta
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div v-if="objCuentaPorCobrar.IdCuentaCobrar>0" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="Id">Empresa</label>
                            <input type="text" class="form-control" disabled v-model="objCuentaPorCobrar.NombreEmpresa">
                        </div>
                        <div v-else class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="Id">Empresa</label>
                            <select v-model="IdSeleccionado" class="form-control-search form-select" id="Id" @change="RellenarCampos()">
                                <option value="">-- Seleccione una Opción --</option>
                                <option v-show="Facturas.length>0" v-for="(item,index) in Facturas" :value="item.IdFactura" :key="index">{{ item.Folio+' - '+item.NombreEmpresa }}</option>
                                <option v-show="NotasVenta.length>0" v-for="(item,index) in NotasVenta" :value="item.IdNotaVenta" :key="index">{{ item.Folio+' - '+item.Cliente }}</option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="Id">Folio</label>
                            <input disabled type="text" v-model="objCuentaPorCobrar.Folio" class="form-control" id="Folio"/>
                            <CValidation v-if="this.errorvalidacion.Folio" :Mensaje="'*'+errorvalidacion.Folio[0]"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <label class="form-label" for="Concepto">Concepto</label>
                            <textarea disabled v-model="objCuentaPorCobrar.Concepto" class="form-control" cols="30" rows="3"></textarea>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="Importe">Importe</label>
                            <input disabled type="text" v-model="objCuentaPorCobrar.TotalPago" class="form-control" id="TotalPago"/>
                            <CValidation v-if="this.errorvalidacion.TotalPago" :Mensaje="'*'+errorvalidacion.TotalPago[0]"/>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="FechaGenerado">Fecha Facturado / Generado</label>
                            <div class="calendar">
                                <Datepicker v-model="objCuentaPorCobrar.FechaGenerado" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00"></Datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="DiasCredito">Días de Crédito</label>
                            <input @input="CalcularFechaPago();" type="text" v-model="objCuentaPorCobrar.DiasCredito" class="form-control" id="DiasCredito"/>
                            <CValidation v-if="this.errorvalidacion.DiasCredito" :Mensaje="'*'+errorvalidacion.DiasCredito[0]"/>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="FechaPago">Fecha de Pago</label>
                            <div class="calendar">
                                <Datepicker @input="CalcularDiaCredito" v-model="objCuentaPorCobrar.FechaPago" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00"></Datepicker>
                            </div>
                            <CValidation v-if="this.errorvalidacion.FechaPago" :Mensaje="'*'+errorvalidacion.FechaPago[0]"/>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';
export default {
    name: 'FormCuentaPorCobrar',
    props: ['poBtnSave','pListaCuentasCobrar'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCuentaPorCobrar:{
                IdCuentaCobrar:0,
                IdFactura:0,
                IdNota:0,
                FechaPago:'',
                FechaGenerado:'',
                TotalPago:0,
                Estatus:'',
                DiasCredito:0,
                Folio:'',
                IdCliente:'',
                IdUsuario:'',
                Observaciones:'',
                FechaCobrado:'',
                IdEmpresa:'',
                IdSucursal:'',
                Concepto:'',
                NombreEmpresa:''
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            Setpicker:Calendar.calendarSettings,
            TipoLista:'',
            IdSeleccionado:'',
            Facturas:[],
            NotasVenta:[],
            ListaCuentasCobrar:[]
            // ListaCuentas:[]
        }
    },
    methods: {
        async Guardar(){
            this.poBtnSave.DisableBtn=true;
            let BndError=false;
            let Mensaje="";
            if (this.TipoLista=='') {
                Mensaje="Debe seleccionar un Tipo de Cuenta";
                BndError=true;
            }
            if (BndError) {
                this.poBtnSave.DisableBtn=false;
                this.$toast.warning(Mensaje);
                return false;
            }
            let FechaPago='';
            if (this.objCuentaPorCobrar.FechaPago!='') {
                let day=this.objCuentaPorCobrar.FechaPago.getDate();
                let month=this.objCuentaPorCobrar.FechaPago.getMonth()+1;
                let year=this.objCuentaPorCobrar.FechaPago.getFullYear();
                FechaPago=year+'-'+month+'-'+day;   
            }

            let formData=new FormData();
            formData.set('IdFactura',this.objCuentaPorCobrar.IdFactura);
            formData.set('IdNota',this.objCuentaPorCobrar.IdNota);
            formData.set('FechaPago',FechaPago);
            formData.set('TotalPago',this.objCuentaPorCobrar.TotalPago);
            formData.set('Estatus','Pendiente');
            formData.set('DiasCredito',this.objCuentaPorCobrar.DiasCredito);
            formData.set('Folio',this.objCuentaPorCobrar.Folio);
            formData.set('IdCliente',this.objCuentaPorCobrar.IdCliente);
            formData.set('IdUsuario',this.objCuentaPorCobrar.IdUsuario);
            formData.set('Observaciones',this.objCuentaPorCobrar.Observaciones);
            formData.set('FechaCobrado',this.objCuentaPorCobrar.FechaCobrado);

            if (this.objCuentaPorCobrar.IdCuentaCobrar==0) {
                this.$http.post("/cuentaPorCobrar",formData
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                });
            }
            else{
                this.$http.post("/cuentaPorCobrar/"+this.objCuentaPorCobrar.IdCuentaCobrar,formData
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                });
            }

        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.ConfigLoad.ShowLoader=true;
            this.$http.get('/cuentaPorCobrar/'+this.objCuentaPorCobrar.IdCuentaCobrar
            ).then((res)=>{
                if (res.data.data.nota_ventas!=undefined || res.data.data.nota_ventas!=null) {
                    this.TipoLista='2';
                    this.objCuentaPorCobrar.NombreEmpresa=res.data.data.nota_ventas.Cliente;
                }
                else{
                    this.TipoLista='1';
                    this.objCuentaPorCobrar.NombreEmpresa=res.data.data.facturas.NombreEmpresa;
                }
                for (let index = 0; index < res.data.detalle.length; index++) {
                    if (index<(res.data.detalle.length-1)) {
                        this.objCuentaPorCobrar.Concepto+=res.data.detalle[index].Descripcion+' - ';
                    }
                    else{
                        this.objCuentaPorCobrar.Concepto+=res.data.detalle[index].Descripcion
                    }
                }
                this.objCuentaPorCobrar.FechaGenerado=new Date();
                this.objCuentaPorCobrar.IdNota=res.data.data.IdNota;
                this.objCuentaPorCobrar.IdFactura=res.data.data.IdFactura;
                let formatedDate = res.data.data.FechaPago.replace(/-/g, "\/");
                this.objCuentaPorCobrar.FechaPago=new Date(formatedDate);
                this.objCuentaPorCobrar.TotalPago=res.data.data.TotalPago;
                this.objCuentaPorCobrar.DiasCredito=res.data.data.DiasCredito;
                this.objCuentaPorCobrar.Folio=res.data.data.Folio;
                this.objCuentaPorCobrar.IdCliente=res.data.data.IdCliente;
                this.objCuentaPorCobrar.IdUsuario=res.data.data.IdUsuario;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });

        },
        Limpiar(){
            this.objCuentaPorCobrar={
                IdCuentaCobrar:0,
                IdFactura:0,
                IdNota:0,
                FechaPago:'',
                TotalPago:0,
                Estatus:'',
                DiasCredito:0,
                Folio:'',
                IdCliente:'',
                IdUsuario:'',
                Observaciones:'',
                FechaCobrado:'',
                NombreEmpresa:'',
                Concepto:''
            },
            this.errorvalidacion=[];
        },
        ListarTipoCuenta(){
            this.objCuentaPorCobrar.IdNota=0;
            this.objCuentaPorCobrar.IdFactura=0;
            this.Facturas=[];
            this.NotasVenta=[];
            switch (this.TipoLista) {
                case '1':
                    this.$http.get('/facturasSimple',{
                        params:{
                            Facturado:'SI'
                        }
                    }).then((res)=>{
                        let FacturasSinFiltro=res.data.data.filter((element)=>{
                            let index=this.ListaCuentasCobrar.findIndex((elementocuenta)=>element.IdFactura==elementocuenta.IdFactura);
                            if (index==-1) {
                                return element;
                            }
                        });
                        this.Facturas=FacturasSinFiltro;
                    })
                    break;
                case '2':
                    this.$http.get('/notaVentasSimple'
                    ).then((res) => {
                        let NotasSinFiltro=res.data.data.filter((element)=>{
                            let index=this.ListaCuentasCobrar.findIndex((elementcuenta)=>element.IdNotaVenta==elementcuenta.IdNota);
                            if (index==-1) {
                                return element
                            }
                        });
                        this.NotasVenta=NotasSinFiltro;
                    })
                    break;
            }
        },
        RellenarCampos(){
            switch (this.TipoLista) {
                case '1':
                    this.$http.get('/facturas/'+this.IdSeleccionado
                    ).then((res)=>{
                        for (let index = 0; index < res.data.detalle.length; index++){
                            if (index<(res.data.detalle.length-1)) {
                                this.objCuentaPorCobrar.Concepto+=res.data.detalle[index].Descripcion+' - ';
                            }
                            else{
                                this.objCuentaPorCobrar.Concepto+=res.data.detalle[index].Descripcion
                            }
                        }
                        this.objCuentaPorCobrar.IdFactura=res.data.data.IdFactura;
                        this.objCuentaPorCobrar.Folio=res.data.data.Folio;
                        this.objCuentaPorCobrar.TotalPago=res.data.data.Total;
                        this.objCuentaPorCobrar.IdCliente=res.data.data.IdCliente;
                        this.objCuentaPorCobrar.IdUsuario=res.data.data.IdUsuario;
                        this.objCuentaPorCobrar.FechaGenerado=res.data.data.factura_timbrado!=undefined ? new Date(res.data.data.factura_timbrado.FechaTimbrado) : new Date();
                        this.objCuentaPorCobrar.DiasCredito=1;
                        this.CalcularFechaPago();
                    })
                    break;
                case '2':
                    this.$http.get('/notaVentas/'+this.IdSeleccionado
                    ).then((res)=>{
                        for (let index = 0; index < res.data.detalle.length; index++) {
                            if (index<(res.data.detalle.length-1)) {
                                this.objCuentaPorCobrar.Concepto+=res.data.detalle[index].Descripcion+' - ';
                            }
                            else{
                                this.objCuentaPorCobrar.Concepto+=res.data.detalle[index].Descripcion
                            }
                        }
                        this.objCuentaPorCobrar.IdNota=res.data.data.IdNotaVenta;
                        this.objCuentaPorCobrar.Folio=res.data.data.Folio;
                        this.objCuentaPorCobrar.TotalPago=res.data.data.Total;
                        this.objCuentaPorCobrar.IdCliente=res.data.data.IdCliente;
                        this.objCuentaPorCobrar.IdUsuario=res.data.data.IdUsuario;
                        this.objCuentaPorCobrar.FechaGenerado=new Date();
                        this.objCuentaPorCobrar.DiasCredito=1;
                        this.CalcularFechaPago();
                    })
                    break;
            }
        },
        CalcularFechaPago(){
            var dateNvo=moment(this.objCuentaPorCobrar.FechaGenerado).format('YYYY-MM-DD');
            var dateEl = dateNvo.split("-");
			var date = new Date(dateEl[0],(dateEl[1]-1),dateEl[2])
            if (this.objCuentaPorCobrar.DiasCredito!="0" || this.objCuentaPorCobrar.DiasCredito!="") {
                var newDate=date.setDate(date.getDate()+Number(this.objCuentaPorCobrar.DiasCredito));
            }
            else{
                var newDate=date.setDate(date.getDate()+2);
            };
            this.objCuentaPorCobrar.FechaPago=new Date(newDate);
            // if (this.objCuentaPorCobrar.DiasCredito!="0" || this.objCuentaPorCobrar.DiasCredito!="") {
            //     var newDate=this.objCuentaPorCobrar.FechaPago.setDate(this.objCuentaPorCobrar.FechaPago.getDate()+Number(this.objCuentaPorCobrar.DiasCredito));
            // }
            // else{
            //     var newDate=this.objCuentaPorCobrar.FechaPago.setDate(this.objCuentaPorCobrar.FechaPago.getDate()+2);
            // };
            // this.objCuentaPorCobrar.FechaPago=newDate;
        },
        CalcularDiaCredito(){
            let DateStrFechaPago=moment(this.objCuentaPorCobrar.FechaPago).format('YYYY-MM-DD');
            let DateStrFechaPagoEl=DateStrFechaPago.split('-');
            let DateFechaPago=new Date(DateStrFechaPagoEl[0],(DateStrFechaPagoEl[1]-1),DateStrFechaPagoEl[2]);
            // console.log(DateStrFechaPago);

            let DateStrFechaGenerado=moment(this.objCuentaPorCobrar.FechaGenerado).format('YYYY-MM-DD');
            let DateStrFechaGeneradoEl=DateStrFechaGenerado.split('-');
            let DateFechaGenerado=new Date(DateStrFechaGeneradoEl[0],(DateStrFechaGeneradoEl[1]-1),DateStrFechaGeneradoEl[2]);

            let FechaPagoCalcular=DateFechaPago.setMinutes(DateFechaPago.getMinutes()-DateFechaPago.getTimezoneOffset());
            let FechaGeneradoCalcular=DateFechaGenerado.setMinutes(DateFechaGenerado.getMinutes()-DateFechaGenerado.getTimezoneOffset());

            this.objCuentaPorCobrar.DiasCredito=Math.round((FechaPagoCalcular-FechaGeneradoCalcular)/(1000*60*60*24));
        }
    },
    created() {
        this.poBtnSave.Toast = 0;
        this.ListaCuentasCobrar=this.pListaCuentasCobrar;
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCuentaPorCobrar.IdCuentaCobrar = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
}
</script>

<style>

</style>